import { useForm } from "react-hook-form";
import { ModalCriativoMensagemStyled } from "./style";
import api from "../../../services/api";
import { toast } from "react-toastify";

export const ModalRemoverVisualizacaoCriativoMensagem = ({ state, criativoMensagem, buscarCriativo }) => {
  const { handleSubmit } = useForm()

  function onSubmitFunction() {

    api.patch(`/criativo-mensagem/${criativoMensagem.id}`, { status: 0 })
      .then((response) => {
        buscarCriativo()
        state(false)
      })
      .catch((error) => {
        console.log(error)
        toast.error(error.response?.data?.message);
      });
  }

  return (
    <ModalCriativoMensagemStyled >
      <form className="div-body">
        <span onClick={() => state(false)} className="close">
          X
        </span>
        <h2 className="tituloRemover">Tem certeza que quer REMOVER essa mensagem para a visualização do cliente?</h2>
        <h3>"{criativoMensagem.comentario}"</h3>
        <div className="buttons">
          <span className="confirmar" onClick={() => onSubmitFunction()}>SIM</span>
          <button className="negar" onClick={() => state(false)}>NÃO</button>
        </div>
      </form>
    </ModalCriativoMensagemStyled>
  );
};